// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__A8JN7","toggle":"styles_toggle__nl-e1","preview":"styles_preview__2-XAP"};